export default class PinMarker {
    static ICON = {
        AVAILABLE_HOME: { name: 'pin-available', class: 'icon-no-verified' },
        AVAILABLE_HOME_HOVER: {
            name: 'pin-available-hover',
            class: 'icon-hover-or-selected-no-verified'
        },
        UNAVAILABLE_HOME: { name: 'pin-unavailable', class: 'icon-dual-no-verified' },
        UNAVAILABLE_HOME_HOVER: {
            name: 'pin-unavailable-hover',
            class: 'icon-hover-or-selected-no-verified'
        },
        FAVORITE_HOME: {
            name: 'pin-favorite-available',
            class: 'icon-available-favorite-home'
        },
        UNAVAILABLE_FAVORITE_HOME: {
            name: 'pin-favorite-unavailable',
            class: 'icon-unavailable-favorite-home'
        },
        FAVORITE_HOME_HOVER: {
            name: 'pin-favorite-available-hover',
            class: 'icon-favorite-home-hover'
        },
        UNAVAILABLE_FAVORITE_HOME_HOVER: {
            name: 'pin-favorite-unavailable-hover',
            class: 'icon-favorite-home-hover'
        }
    };

    static PATH_MARKER = {
        [PinMarker.ICON.AVAILABLE_HOME.class]: 2,
        [PinMarker.ICON.AVAILABLE_HOME_HOVER.class]: 2,
        [PinMarker.ICON.UNAVAILABLE_HOME.class]: 2,
        [PinMarker.ICON.UNAVAILABLE_HOME_HOVER.class]: 2,
        [PinMarker.ICON.FAVORITE_HOME.class]: 2,
        [PinMarker.ICON.UNAVAILABLE_FAVORITE_HOME.class]: 2,
        [PinMarker.ICON.FAVORITE_HOME_HOVER.class]: 2
    };

    static MAP_LEGENDS = [
        {
            iconClass: PinMarker.ICON.AVAILABLE_HOME.class,
            iconCount: PinMarker.PATH_MARKER[PinMarker.ICON.AVAILABLE_HOME.class],
            text: 'home:pin-legend-no-verified'
        },
        {
            iconClass: PinMarker.ICON.UNAVAILABLE_HOME.class,
            iconCount: PinMarker.PATH_MARKER[PinMarker.ICON.UNAVAILABLE_HOME.class],
            text: 'home:pin-legend-dual-no-verified'
        },
        {
            iconClass: PinMarker.ICON.FAVORITE_HOME.class,
            iconCount: PinMarker.PATH_MARKER[PinMarker.ICON.FAVORITE_HOME.class],
            text: 'home:pin-legend-favorite-home'
        },
        {
            iconClass: PinMarker.ICON.UNAVAILABLE_FAVORITE_HOME.class,
            iconCount: PinMarker.PATH_MARKER[PinMarker.ICON.UNAVAILABLE_FAVORITE_HOME.class],
            text: 'home:pin-legend-unavailable-favorite-home'
        }
    ];

    static getPathMarker = (imgSrc) => {
        return PinMarker.PATH_MARKER[imgSrc];
    };

    static getMarkerTrackingId = (marker) => {
        switch (marker) {
            case PinMarker.ICON.AVAILABLE_HOME.name:
            case PinMarker.ICON.AVAILABLE_HOME_HOVER.name:
                return 'click_pin_available';
            case PinMarker.ICON.UNAVAILABLE_HOME.name:
            case PinMarker.ICON.UNAVAILABLE_HOME_HOVER.name:
                return 'click_pin_unavailable';
            case PinMarker.ICON.FAVORITE_HOME.name:
            case PinMarker.ICON.FAVORITE_HOME_HOVER.name:
                return 'click_pin_favorite_available';
            case PinMarker.ICON.UNAVAILABLE_FAVORITE_HOME.name:
            case PinMarker.ICON.UNAVAILABLE_FAVORITE_HOME_HOVER.name:
                return 'click_pin_favorite_unavailable';
            default:
                break;
        }
    };

    static isFavoriteHomeIcon = (icon) =>
        [
            PinMarker.ICON.UNAVAILABLE_FAVORITE_HOME,
            PinMarker.ICON.FAVORITE_HOME,
            PinMarker.ICON.FAVORITE_HOME_HOVER
        ].includes(icon);
}
